import { useEffect, useState } from "react";
import DeleteIcon from "../../assets/images/DeleteIcon";
import {
  StaffListConstants,
} from "../../constants/constants";
import PersonalInformationDynamic from "./PersonalInformationDynamic";
const tableHeaderStyle = "text-black staffListHeader font-nunito ";
const tableDataStyle = "text-center quickLinksDescription text-black";
const RolesAndPermissionTable = ({
  userDetail,
  handleDeleteButtonChange,
  showRolesTableInEditFlow,
  order,
  addMoreRolesInfo,
  setEditPayloadjson,
  isEditMode,
  jsonForEditData,
  editModeForRolesDetails,
  rolesDetailsIndex,
  addMoreRoles,
  handleEditRolesInformation,
  errors,
  setIsSaveButtonClicked,
  isSaveButtonCLicked,
  setErrors,
  setIsSpecilizationManditory,
  handleDeleteButtonChangeForOnboardFlow,
  handleDeleteButtonChangeForEditFlow,
  isDeletingRef,
  setShowFeildsToAddMoreRoles,
  isPreviousButtonClicked,
  setSelectedSpecializationList,
  selectedSpecializationList,
}: {
  userDetail: any;
  handleDeleteButtonChange?: (index: number) => void;
  order?: any;
  addMoreRolesInfo?: any;
  setEditPayloadjson?: any;
  jsonForEditData?: any;
  isEditMode?: boolean;
  showRolesTableInEditFlow?: any;
  editModeForRolesDetails?: any;
  rolesDetailsIndex?: any;
  addMoreRoles?: any;
  handleEditRolesInformation?: any;
  errors?: any;
  setIsSaveButtonClicked?:any;
  isSaveButtonCLicked?:any;
  setErrors?:any;
  setIsSpecilizationManditory?: any;
  handleDeleteButtonChangeForOnboardFlow?:any;
  handleDeleteButtonChangeForEditFlow?:any;
  isDeletingRef?:any;
  setShowFeildsToAddMoreRoles?:any;
  isPreviousButtonClicked?:any;
  setSelectedSpecializationList?:any;
  selectedSpecializationList?:any;
}) => {
  let RolesInfo: any[] = [];
  // useEffect(() => {
  if (isEditMode) {
    RolesInfo = userDetail[order]?.subSegments.filter(
      (item: { name: string }) => item.name === "Roles"
    );
  } else {
      RolesInfo = userDetail;
  }
useEffect(() => {
  console.log("RolesInfo", RolesInfo,userDetail); 
},[userDetail]);
  const rolesDetailforedit = () => {
    return {
      segmentId: userDetail[order]?.segmentId,
      name: userDetail[order]?.name,
      description: userDetail[order]?.description,
      segmentOrder: userDetail[order]?.segmentOrder,
      subSegments: [RolesInfo ? addMoreRolesInfoForEdit() : RolesInfo[0]],
    };
  };

  const addMoreRolesInfoForEdit = () => {
    if (!jsonForEditData) return null;

    const firstRolesInfo = addMoreRolesInfo
      ? jsonForEditData?.formSegments[order]?.subSegments.find(
          (subSegment: any) => subSegment.name === "Roles"
        )
      : userDetail[order]?.subSegments.find(
          (subSegment: any) => subSegment.name === "Roles"
        );

    if (!firstRolesInfo) return null;

    const clearedRolesInfo = JSON.parse(JSON.stringify(firstRolesInfo));
    clearedRolesInfo?.attributes?.forEach((attr: any) => {
    return attr.value = null;
  });
    return clearedRolesInfo;
  };

  const removeEmptyRolesInfo = (formSegment: any) => {
    // Get all Educational Information subSegments
    const educationalInfos = formSegment.subSegments.filter(
      (sub: any) => sub.name === "Roles"
    );
  
    // Get the LAST "Educational Information"
    const lastEducationalInfo = educationalInfos[educationalInfos.length - 1];
  
    // Check if all attributes are empty
    const areAllAttributesEmpty = (subSegment: any): boolean => {
      return subSegment?.attributes?.every(
        (attr: any) =>
          attr.value === "" || attr.value === null || attr.value === undefined
      );
    };
  
    console.log("Is last Educational Info empty?", areAllAttributesEmpty(lastEducationalInfo));
  
    return areAllAttributesEmpty(lastEducationalInfo);
  };
  useEffect(() => {
    if (addMoreRolesInfo) {
      console.log("inside addMoreRolesInfo", addMoreRolesInfo);
      if(!removeEmptyRolesInfo(jsonForEditData?.formSegments[order])){
        jsonForEditData?.formSegments[order]?.subSegments.push(
          addMoreRolesInfoForEdit()
             );
             }
    }
  }, [addMoreRolesInfo]);

  useEffect(() => {
    setJsonForEdit(rolesDetailforedit());
  }, []);

  const [jsonForEdit, setJsonForEdit] = useState<any>();
  const [tempFlag, setTempFlag] = useState<boolean>(true);

  useEffect(() => {
    if ((addMoreRolesInfo && tempFlag) || showRolesTableInEditFlow) {
      setJsonForEdit(rolesDetailforedit());
      setTempFlag(false);
    }
  }, [addMoreRolesInfo, userDetail, jsonForEditData]);

  return (
    <div>
      {/* <div className="bg-primary px-4 py-2 w-24 text-whiteColor" onClick={()=>{}}>Adddd</div> */}
      {addMoreRoles ? (
        <div>
          <PersonalInformationDynamic
            jsonObjForEdit={addMoreRolesInfo ? jsonForEditData : [userDetail]}
            jsonobj={[jsonForEdit]} // Wrap the returned object in an array
            order={0}
            isEditMode={true}
            indexOfValueToBeModified={rolesDetailsIndex}
            setEditPayloadjson={setEditPayloadjson}
            addMoreRolesInfo={addMoreRolesInfo}
            // addmoreEducationOrder={order}
            addmoreRolesOrder={order}
            setJsonForEditFlow={setJsonForEdit}
            showRolesTableInEditFlow={showRolesTableInEditFlow}
            isSaveButtonCLicked={isSaveButtonCLicked}
            setIsSaveButtonClicked={setIsSaveButtonClicked}
            errors={errors}
            setErrors={setErrors}
            setIsSpecilizationManditory={setIsSpecilizationManditory}
            setSelectedSpecializationList={setSelectedSpecializationList}
      selectedSpecializationList={selectedSpecializationList}
            // setEditPayloadjson={setEditPayloadjson}
          />
        </div>
      ) : (
        <>
          <div className="block lg:hidden">
            <div className="flex flex-col gap-4">
            {RolesInfo
  ?.filter((item: any) => item.name === "Roles")
  .map((item: any, index: number) => {
                // Extracting values from attributes array
                const attributes = item?.attributes?.reduce(
                  (acc: any, attr: any) => {
                    acc[attr.name] = attr?.value;
                    return acc;
                  },
                  {}
                );
                return (
                  <div
                    key={index}
                    className="bg-white shadow-md rounded-xl p-4 cursor-pointer hover:shadow-lg border border-gray-300"
                  >
                    <div className="flex justify-between items-start  gap-4">
                      <div>
                        <div className="font-nunitolabelText label label  text-label text-black">
                          {StaffListConstants.department}
                        </div>
                        <div className="text-black employeeId mb-3">
                          {isEditMode ? 
                            jsonForEditData?.valueMap?.deptId[
                              attributes["deptId"] 
                            ] : attributes?.deptId
                          }
                        </div>
                      </div>

                      <div>
                        <div className="font-nunitolabelText label  text-label text-black">
                          {StaffListConstants.GroupRole}
                        </div>
                        <div className="text-black employeeId mb-3">
                          {isEditMode ?
                            jsonForEditData?.valueMap?.groupId[
                              attributes["groupId"]
                            ]: attributes?.groupId
                          }
                        </div>
                      </div>
                      <div>
                        <div className="font-nunitolabelText label  text-label text-black">
                          {StaffListConstants.baseRole}
                        </div>
                        <div className="text-black employeeId mb-3">
                          {isEditMode ?
                            jsonForEditData?.valueMap?.roleId[
                              attributes["roleId"]
                            ]: attributes?.roleId
                          }
                        </div>
                      </div>
                    </div>
                    <div className="flex justify-between items-start gap-4">
                      <div>
                        <div className="font-nunito  label  text-label text-black">
                          {StaffListConstants.Type}
                        </div>
                        <div className="text-black employeeId mb-3">
                          {isEditMode ?
                            jsonForEditData?.valueMap?.typeId[
                              attributes["typeId"]
                            ]: attributes?.typeId
                          }
                        </div>
                      </div>
                      <div>
                        <div className="font-nunito  label  text-label  text-black">
                          {StaffListConstants.ProductSpecialization}
                        </div>
                        <div className="text-black employeeId mb-3">
                          {isEditMode ?
                            jsonForEditData?.valueMap?.specializationIds[
                              attributes["specializationIds"]
                            ]: attributes?.specializationIds
                          }
                        </div>
                      </div>
                    </div>
                    <div className="flex justify-end items-center ">
                      <div className="flex items-center gap-3 ">
                        <button
                          className="text-primary flex items-center"
                          onClick={() => {
                            isEditMode ?
                            handleDeleteButtonChangeForEditFlow(index)
                            : handleDeleteButtonChangeForOnboardFlow(index)
                          }}
                        >
                          <DeleteIcon />
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className=" hidden lg:block">
            <div>
              <div>
                <table className="w-full my-8 border border-gray-300">
                  <thead className="bg-sideMenubackground h-[64px]">
                    <tr>
                      <th className={`pl-8 ${tableHeaderStyle} `}>
                        {StaffListConstants.department}
                      </th>
                      <th className={tableHeaderStyle}>
                        {StaffListConstants.GroupRole}
                      </th>
                      <th className={tableHeaderStyle}>
                        {StaffListConstants.baseRole}
                      </th>
                      <th className={tableHeaderStyle}>
                        {StaffListConstants.Type}
                      </th>
                      <th className={tableHeaderStyle}>
                        {StaffListConstants.ProductSpecialization}
                      </th>
                      {/* <th className={tableHeaderStyle}>
                    {StaffListConstants.MultipleBranchAccess}
                  </th> */}
                      <th className={`pr-8 ${tableHeaderStyle}`}>
                        {StaffListConstants.Action}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                  {RolesInfo
  ?.filter((item: any) => item.name === "Roles")
  .map((item: any, index: number) => {
                      console.log("item", item);
                      // Extracting values from attributes array
                      const attributes = item?.attributes?.reduce(
                        (acc: any, attr: any) => {

                          console.log("attr", attr, acc);
                          acc[attr.name] = attr?.value;
                          return acc;
                        },
                        {}
                      );
                      return (
                        <tr className="border-b" key={index}>
                          <td className={tableDataStyle}>
                          {isEditMode ? 
                            jsonForEditData?.valueMap?.deptId[
                              attributes["deptId"] 
                            ] : attributes?.deptId
                          }
                          </td>

                          <td className={tableDataStyle}>
                            { isEditMode ?
                              jsonForEditData?.valueMap?.groupId[
                                attributes["groupId"]
                              ] : attributes?.groupId
                            }
                             
                          
                          </td>

                          <td className={tableDataStyle}>
                            {isEditMode ?
                              jsonForEditData?.valueMap?.roleId[
                                attributes["roleId"]
                              ]: attributes?.roleId
                            }
                          </td>

                          <td className={tableDataStyle}>
                            {isEditMode ?
                              jsonForEditData?.valueMap?.typeId[
                                attributes["typeId"]
                              ]: attributes?.typeId
                            }
                          </td>

                          <td className={tableDataStyle}>
                            {isEditMode ?
                             attributes?.specializationIds
                              ?.map((id: string | number) => jsonForEditData?.valueMap?.specializationIds?.[id])
                              .filter(Boolean)
                              .join(", "): attributes?.specializationIds
                            }
                          </td>

                          {/* Action */}
                          <td className={tableDataStyle}
                           onClick={() => {
                            if (isEditMode) {
                              isDeletingRef.current = true;
                              handleDeleteButtonChangeForEditFlow(index);
                            } else {
                              handleDeleteButtonChangeForOnboardFlow(index);
                            }
                          }}>
                            <DeleteIcon />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default RolesAndPermissionTable;
